import { EnumUtils } from '@colonist/utils';
import { RankedModeTypes } from '../../../../shared/GameEnums.ts';
import { LeaderboardConstants } from '../../../../shared/leaderboard_data/LeaderboardConstants.ts';
export function parseLeaderboardsUrlState(url) {
    const [urlWithoutHash] = url.split('#');
    const [pathOnly, query] = urlWithoutHash.split('?');
    const pathSegments = pathOnly.split('/');
    const leaderboardsIndex = pathSegments.indexOf('leaderboards');
    if (leaderboardsIndex < 0) return {};
    const urlState = {};
    const rankedMode = EnumUtils.getEnumValue(pathSegments[leaderboardsIndex + 1], RankedModeTypes);
    if (rankedMode != undefined) urlState.rankedModeType = rankedMode;
    const leaderboardUrl = pathSegments.slice(leaderboardsIndex + 2).join('/');
    urlState.leaderboardUrl = leaderboardUrl ? leaderboardUrl : LeaderboardConstants.globalLeaderboardUrl;
    const params = new URLSearchParams(query !== null && query !== void 0 ? query : '');
    var _params_get;
    urlState.searchTerm = (_params_get = params.get('q')) !== null && _params_get !== void 0 ? _params_get : '';
    return urlState;
}
